import { render } from "./gybDetail.vue?vue&type=template&id=3280b6fd&scoped=true"
import script from "./gybDetail.vue?vue&type=script&lang=js"
export * from "./gybDetail.vue?vue&type=script&lang=js"

import "./gybDetail.vue?vue&type=style&index=0&id=3280b6fd&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3280b6fd"]])

export default __exports__